import { provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { AppModule, loggerCallback } from './app/app.module';
import { MSAL_INSTANCE } from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  LogLevel,
  PublicClientApplication,
} from '@azure/msal-browser';
import { theming } from './theme/theme';

const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1;
const currentUrl = encodeURIComponent(window.location.href);

interface Config {
  tenantName: string;
  clientId: string;
  redirectUrl: string;
  policyId: string;
}

async function getConfigurations(currentUrl: string): Promise<Config> {
  const response = await fetch(
    `${window.location.origin}/api/config?config=msal&currentUrl=${currentUrl}`,
  );

  if (!response.ok) {
    throw new Error(`Failed to load application configuration: ${response.status}`);
  }

  return (await response.json()) as Config;
}

const configurations = getConfigurations(currentUrl);
configurations.then((configResponse) => {
  const config: Config = configResponse
    ? (configResponse as Config)
    : {
        tenantName: '',
        clientId: '',
        redirectUrl: '',
        policyId: '',
      };
  platformBrowser([
    {
      provide: MSAL_INSTANCE,
      useValue: new PublicClientApplication({
        auth: {
          clientId: config.clientId,
          authority: `https://${config.tenantName}.b2clogin.com/tfp/${config.tenantName}.onmicrosoft.com/${config.policyId}`,
          knownAuthorities: [`${config.tenantName}.b2clogin.com`],
          redirectUri: config.redirectUrl, // Uri must be registered on Azure. Points to window.location.origin by default.
          navigateToLoginRequestUrl: false,
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage,
          storeAuthStateInCookie: isIE, // set to true for IE 11
        },
        system: {
          loggerOptions: {
            loggerCallback,
            logLevel: LogLevel.Warning,
            piiLoggingEnabled: false,
          },
          allowPlatformBroker: false,
        },
      }),
    },
  ])
    .bootstrapModule(AppModule, {
      applicationProviders: [provideZoneChangeDetection()],
    })
    .catch((err) => console.error(err));
  theming(currentUrl);
});
